// TelcoTrack – shared “Ukázat pouze aktivní” filter helpers (polygons page parity)

import type { Polygon } from '../../core/models/polygon.model';
import { filterActivePolygons, isPolygonActive } from './polygon-project-tracking.util';

/** Default checkbox state across portfolio tables (matches Polygons list). */
export const DEFAULT_SHOW_ACTIVE_POLYGONS_ONLY = true;

/** Send `activePolygonOnly=true` only when checkbox is on and no explicit polygon filter. */
export function shouldSendActivePolygonOnly(
  showActiveOnly: boolean,
  hasSpecificPolygonFilter: boolean,
): boolean {
  return showActiveOnly && !hasSpecificPolygonFilter;
}

export function buildActivePolygonIdSet(polygons: Iterable<Polygon>): Set<string> {
  const ids = new Set<string>();
  for (const p of polygons) {
    const id = (p.id ?? '').trim();
    if (id && isPolygonActive(p)) ids.add(id);
  }
  return ids;
}

export function polygonsForActiveFilterDropdown(polygons: Polygon[], showActiveOnly: boolean): Polygon[] {
  return showActiveOnly ? filterActivePolygons(polygons) : polygons;
}

export function filterRowsByActivePolygon<T>(
  rows: T[],
  showActiveOnly: boolean,
  activePolygonIds: Set<string>,
  getPolygonId: (row: T) => string | null | undefined,
  hasSpecificPolygonFilter = false,
): T[] {
  if (!shouldSendActivePolygonOnly(showActiveOnly, hasSpecificPolygonFilter)) return rows;
  return rows.filter((row) => {
    const pid = (getPolygonId(row) ?? '').trim();
    if (!pid) return true;
    return activePolygonIds.has(pid);
  });
}
